export const companyInfo = {
  name: 'Infinite Consultant & Services',
  tagline: 'Transforming Spaces, Enhancing Lives',
  gstNo: '29EEPPS2211C1ZH',
  phone1: '+91 70199 08718',
  phone2: '+91 9886657862',
  email: 'infiniteconsultant2442@gmail.com',
  address: 'No.3, First Floor, RV Road, South End Circle, Bangalore - 560011',
  facebook: 'https://www.facebook.com/infiniteconsultantandservices',
  logo: 'https://storage.readdy-site.link/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/f6da8d2f-add5-459f-af6f-e92fab0f29a7_compressed_logo-1.webp',
};

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Projects', href: '#projects' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact', href: '#contact' },
];

export const heroData = {
  headline: 'Transforming Spaces, Enhancing Lives',
  subHeading: 'Your Trusted Partner for Complete Property Solutions.',
  description:
    'We provide complete solutions for Residential, Commercial, Villas, Apartments, Resorts, Offices and Industrial Projects including Landscaping, Interiors, Civil Construction, Fabrication, Cleaning, Waterproofing, Branding and Annual Maintenance Contracts.',
  cta1: 'Get Free Quotation',
  cta2: 'Call Now',
  cta3: 'WhatsApp Now',
};

export const aboutData = {
  title: 'About Us',
  subtitle: 'Building Excellence Since Day One',
  paragraphs: [
    'Infinite Consultant & Services is a Bangalore-based company providing complete property development, maintenance and consultancy services.',
    'We deliver quality workmanship, timely execution, innovative designs and customer satisfaction through our experienced professionals.',
    'Whether you need landscaping, interiors, fabrication, construction, cleaning or annual maintenance, we provide complete end-to-end solutions under one roof.',
  ],
  stats: [
    { value: '500', suffix: '+', label: 'Projects Completed' },
    { value: '12', suffix: '+', label: 'Years Experience' },
    { value: '100', suffix: '%', label: 'Client Satisfaction' },
    { value: '50', suffix: '+', label: 'Expert Team Members' },
  ],
};

export const servicesData = [
  {
    category: 'Natural & Artificial Landscaping',
    icon: 'ri-plant-line',
    items: ['Vertical Garden', 'Lawn Turf', 'FRP Pots', 'Zen Garden', 'Pebbles', 'Independent Houses', 'Apartments', 'Villas', 'Resorts', 'Commercial Properties'],
  },
  {
    category: 'UPVC Windows & Aluminium Works',
    icon: 'ri-window-line',
    items: ['UPVC Windows', 'UPVC Doors', 'Sliding Systems', 'Glass Works', 'Partitions', 'Aluminium Fabrication'],
  },
  {
    category: 'Interior Works',
    icon: 'ri-home-smile-line',
    items: ['Modular Kitchen', 'Wardrobes', 'TV Units', 'False Ceiling', 'Office Interiors', 'Customised Furniture', 'Complete Interior Solutions'],
  },
  {
    category: 'WPC Paneling & Flooring',
    icon: 'ri-layout-masonry-line',
    items: ['WPC Wall Panels', 'Wall Cladding', 'Tile Flooring', 'Vinyl Flooring', 'Decorative Panels'],
  },
  {
    category: 'Indoor & Outdoor Branding',
    icon: 'ri-flag-line',
    items: ['Frost Stickers', 'Sunboard', '2D Sign Boards', '3D Sign Boards', 'ACP Sign Boards', 'Office Branding', 'Shop Branding'],
  },
  {
    category: 'SS & MS Fabrication',
    icon: 'ri-tools-line',
    items: ['SS Fabrication', 'MS Fabrication', 'Railings', 'Gates', 'Handrails', 'Structural Works', 'Custom Fabrication'],
  },
  {
    category: 'Electrical, Plumbing & Painting',
    icon: 'ri-flashlight-line',
    items: ['Electrical Installation', 'Electrical Maintenance', 'Plumbing', 'Interior Painting', 'Exterior Painting', 'Repair Services'],
  },
  {
    category: 'Civil & Waterproofing',
    icon: 'ri-building-line',
    items: ['Civil Construction', 'Renovation', 'Terrace Waterproofing', 'Bathroom Waterproofing', 'Leakage Solutions', 'Repair Works'],
  },
  {
    category: 'Deep Cleaning',
    icon: 'ri-sparkling-line',
    items: ['Houses', 'Apartments', 'Villas', 'Hospitals', 'Commercial Buildings', 'Resorts', 'Offices'],
  },
  {
    category: 'Annual Maintenance Contract (AMC)',
    icon: 'ri-shield-check-line',
    items: ['Regular Maintenance', 'Preventive Maintenance', 'Emergency Support', 'Affordable AMC Packages', 'Professional Support Team'],
  },
  {
    category: 'Flooring & Wall Paneling',
    icon: 'ri-layout-masonry-line',
    items: ['SPC Flooring', 'Wooden Flooring', 'Vinyl Flooring', 'Laminate Flooring', 'WPC Decking', 'WPC Wall Panels', 'PVC Wall Panels', 'Decorative Panels', 'Acoustic Panels', 'Interior Wall Cladding'],
  },
  {
    category: 'Swimming Pool & Fountain Solutions',
    icon: 'ri-water-flash-line',
    items: ['Residential Swimming Pools', 'Commercial Pools', 'Infinity Pools', 'Indoor Pools', 'Outdoor Pools', 'Water Fountains', 'Musical Fountains', 'Landscape Water Features', 'Pool Renovation', 'Pool Maintenance'],
  },
  {
    category: 'CCTV Surveillance',
    icon: 'ri-camera-line',
    items: ['Homes', 'Offices', 'Commercial Buildings', 'Apartments', 'Villas', 'Warehouses', 'Schools', 'Hospitals', 'Industrial Facilities'],
  },
];

export const whyChooseUsData = [
  { icon: 'ri-user-star-line', title: 'Experienced Professionals' },
  { icon: 'ri-award-line', title: 'Quality Materials' },
  { icon: 'ri-price-tag-3-line', title: 'Affordable Pricing' },
  { icon: 'ri-cpu-line', title: 'Latest Technology' },
  { icon: 'ri-stack-line', title: 'One Stop Solution' },
  { icon: 'ri-shield-check-line', title: 'Reliable Service' },
  { icon: 'ri-time-line', title: 'Timely Delivery' },
  { icon: 'ri-team-line', title: 'Professional Team' },
  { icon: 'ri-file-list-3-line', title: 'Transparent Pricing' },
  { icon: 'ri-emotion-happy-line', title: 'Customer Satisfaction' },
];

export const industriesData = [
  'Independent Houses',
  'Apartments',
  'Villas',
  'Commercial Buildings',
  'Hospitals',
  'Hotels',
  'Resorts',
  'Retail Stores',
  'Corporate Offices',
  'Educational Institutions',
  'Industrial Buildings',
];

export const projectsData = [
  { id: 1, title: 'Luxury Villa Landscaping', category: 'Landscaping', image: 'https://readdy.ai/api/search-image?query=Stunning%20Indian%20luxury%20villa%20garden%20landscaping%20Bangalore%20with%20tropical%20plants%20coconut%20palms%20green%20lawn%20natural%20stone%20pathway%20terracotta%20pots%20bougainvillea%20warm%20golden%20hour%20light%20premium%20residential%20outdoor%20photography&width=800&height=600&seq=proj-land-1&orientation=landscape&nocache=true' },
  { id: 2, title: 'Modern Office Interior', category: 'Interiors', image: 'https://readdy.ai/api/search-image?query=Modern%20Indian%20corporate%20office%20interior%20Bangalore%20open%20plan%20workspace%20with%20wooden%20desks%20indoor%20plants%20glass%20partitions%20ergonomic%20chairs%20warm%20ambient%20lighting%20professional%20workspace%20photography&width=800&height=600&seq=proj-int-1&orientation=landscape&nocache=true' },
  { id: 3, title: 'Commercial Building Construction', category: 'Civil', image: 'https://readdy.ai/api/search-image?query=Modern%20Indian%20commercial%20building%20under%20construction%20Bangalore%20with%20Indian%20workers%20in%20safety%20helmets%20and%20vests%20steel%20framework%20concrete%20structure%20bright%20sunny%20day%20urban%20development%20professional%20photography&width=800&height=600&seq=proj-civ-1&orientation=landscape&nocache=true' },
  { id: 4, title: 'Hospital Deep Cleaning', category: 'Cleaning', image: 'https://readdy.ai/api/search-image?query=Indian%20professional%20cleaning%20staff%20in%20uniform%20working%20inside%20a%20bright%20modern%20hospital%20corridor%20in%20Bangalore%20spotless%20sterile%20environment%20medical%20facility%20professional%20cleaning%20photography&width=800&height=600&seq=proj-cln-1&orientation=landscape&nocache=true' },
  { id: 5, title: '3D Sign Board Branding', category: 'Branding', image: 'https://storage.readdy-site.link/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/e76a2caf-6b90-46c7-ae35-e8e6de5acb47_compressed_ChatGPT-Image-Jul-18-2026-10_56_36-AM.webp' },
  { id: 6, title: 'UPVC Window Installation', category: 'UPVC', image: 'https://readdy.ai/api/search-image?query=Modern%20white%20UPVC%20sliding%20windows%20installed%20in%20a%20contemporary%20Indian%20apartment%20Bangalore%20bright%20natural%20daylight%20green%20garden%20visible%20through%20glass%20premium%20residential%20interior%20professional%20photography&width=800&height=600&seq=proj-upv-1&orientation=landscape&nocache=true' },
  { id: 7, title: 'SS Railing Fabrication', category: 'Fabrication', image: 'https://readdy.ai/api/search-image?query=Stainless%20steel%20railing%20on%20modern%20staircase%20in%20a%20luxury%20Indian%20home%20Bangalore%20with%20glass%20panels%20polished%20metal%20elegant%20interior%20with%20warm%20lighting%20professional%20photography&width=800&height=600&seq=proj-fab-1&orientation=landscape&nocache=true' },
  { id: 8, title: 'WPC Flooring Project', category: 'Flooring', image: 'https://readdy.ai/api/search-image?query=Modern%20Indian%20living%20room%20interior%20with%20elegant%20WPC%20wood%20plastic%20composite%20flooring%20Bangalore%20warm%20wood%20tones%20contemporary%20furniture%20natural%20daylight%20premium%20residential%20photography&width=800&height=600&seq=proj-flr-1&orientation=landscape&nocache=true' },
  { id: 9, title: 'Terrace Waterproofing', category: 'Waterproofing', image: 'https://readdy.ai/api/search-image?query=Indian%20construction%20workers%20wearing%20safety%20gear%20applying%20waterproofing%20membrane%20on%20a%20Bangalore%20apartment%20building%20terrace%20professional%20team%20bright%20sunny%20day%20urban%20rooftop%20civil%20engineering%20photography&width=800&height=600&seq=proj-wtr-1&orientation=landscape&nocache=true' },
];

export const projectCategories = ['All', 'Landscaping', 'Interiors', 'Civil', 'Cleaning', 'Branding', 'UPVC', 'Fabrication', 'Flooring', 'Waterproofing'];

export const testimonialsData = [
  {
    id: 1,
    name: 'Ravi Kumar',
    designation: 'Homeowner',
    location: 'Basaveshwaranagar, Bangalore',
    text: 'Infinite Consultant transformed our barren backyard into a stunning tropical garden. The team understood our vision perfectly and executed it with remarkable attention to detail. Every plant, every stone pathway, and the lighting setup exceeded our expectations. Highly recommended for anyone serious about quality landscaping.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20lush%20tropical%20Indian%20garden%20in%20Bangalore%20with%20vibrant%20green%20lawn%20red%20bougainvillea%20flowers%20coconut%20palm%20natural%20stone%20pathway%20warm%20sunlight%20premium%20landscaping%20project&width=120&height=120&seq=proj-thumb-01&orientation=squarish',
  },
  {
    id: 2,
    name: 'Priya Sharma',
    designation: 'Business Owner',
    location: 'Jayanagar, Bangalore',
    text: 'We trusted Infinite Consultant with our entire office interior redesign and they delivered beyond what we imagined. The modular workstations, the breakout zones, and the lighting design completely transformed our workspace. Our team productivity and morale have noticeably improved since the renovation.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Modern%20clean%20Indian%20corporate%20office%20interior%20Bangalore%20with%20white%20desks%20ergonomic%20chairs%20indoor%20plants%20glass%20partitions%20bright%20natural%20daylight%20professional%20workspace&width=120&height=120&seq=proj-thumb-02&orientation=squarish',
  },
  {
    id: 3,
    name: 'Arun Nair',
    designation: 'Facility Manager',
    location: 'Whitefield, Bangalore',
    text: 'Their Annual Maintenance Contract has been a game-changer for our commercial building. Quick emergency response, thorough preventive checks, and a professional team that actually cares about keeping everything running smoothly. We have renewed our AMC with them for the third consecutive year.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20building%20exterior%20Bangalore%20India%20glass%20facade%20professional%20facility%20management%20well%20maintained%20property%20blue%20sky%20daytime%20corporate%20architecture&width=120&height=120&seq=proj-thumb-03&orientation=squarish',
  },
  {
    id: 4,
    name: 'Divya Reddy',
    designation: 'Villa Owner',
    location: 'HSR Layout, Bangalore',
    text: 'Handling a villa project with multiple contractors is usually a nightmare, but Infinite Consultant made it effortless. They managed everything — landscaping, interiors, waterproofing, and fabrication — under one roof. Exceptional coordination, transparent billing, and outstanding final quality. Truly a one-stop solution.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Luxury%20Indian%20villa%20exterior%20Bangalore%20with%20contemporary%20architecture%20landscaped%20garden%20driveway%20warm%20evening%20golden%20light%20premium%20residential%20property&width=120&height=120&seq=proj-thumb-04&orientation=squarish',
  },
  {
    id: 5,
    name: 'Karthik Iyer',
    designation: 'Retail Store Owner',
    location: 'Indiranagar, Bangalore',
    text: 'The 3D signage and storefront branding they designed for our boutique has completely elevated our street presence. Walk-in customers have nearly doubled since the new signage went up. The team understood our brand aesthetic and executed it flawlessly. Great value for the investment.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Premium%20Indian%20retail%20storefront%20Bangalore%20with%20illuminated%20signage%20modern%20glass%20facade%20warm%20evening%20light%20upscale%20commercial%20branding%20shop%20exterior&width=120&height=120&seq=proj-thumb-05&orientation=squarish',
  },
  {
    id: 6,
    name: 'Meera Joshi',
    designation: 'Hospital Administrator',
    location: 'Koramangala, Bangalore',
    text: 'Deep cleaning a hospital requires specialised expertise and Infinite Consultant delivered impeccably. Their team followed all hygiene protocols, worked around our operational hours, and left every surface spotless. The professionalism and thoroughness were impressive. We have now signed them on a quarterly cleaning contract.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Clean%20bright%20modern%20hospital%20corridor%20in%20Bangalore%20India%20spotless%20floors%20white%20walls%20professional%20medical%20facility%20pristine%20sterile%20environment&width=120&height=120&seq=proj-thumb-06&orientation=squarish',
  },
  {
    id: 7,
    name: 'Sunil Verma',
    designation: 'Property Developer',
    location: 'Sarjapur Road, Bangalore',
    text: 'We installed UPVC windows across our entire apartment complex through Infinite Consultant. The noise reduction and thermal insulation have been remarkable — residents have consistently praised the upgrade. The installation team was punctual, tidy, and completed the project ahead of schedule.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Indian%20apartment%20building%20Bangalore%20with%20white%20UPVC%20windows%20installed%20natural%20daylight%20clear%20blue%20sky%20residential%20architecture%20project&width=120&height=120&seq=proj-thumb-07&orientation=squarish',
  },
  {
    id: 8,
    name: 'Ananya Patel',
    designation: 'Resident Welfare President',
    location: 'JP Nagar, Bangalore',
    text: 'Our apartment complex had severe leakage issues across multiple blocks. Infinite Consultant diagnosed the root causes, proposed a comprehensive waterproofing solution, and executed the repairs with minimal disruption to residents. No leaks through two monsoon seasons now. Excellent problem-solving and workmanship.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Renovated%20Indian%20apartment%20complex%20Bangalore%20after%20professional%20waterproofing%20treatment%20clean%20facade%20fresh%20paint%20modern%20residential%20building%20sunny%20day&width=120&height=120&seq=proj-thumb-08&orientation=squarish',
  },
  {
    id: 9,
    name: 'Vikram Shetty',
    designation: 'Resort Owner',
    location: 'Kanakapura Road, Bangalore',
    text: 'The WPC flooring installation across our resort cottages was executed with exceptional craftsmanship. The team worked efficiently without disrupting our guest operations, and the finish is flawless. The flooring has held up beautifully even in high-traffic areas. We are planning our next phase of renovation with them.',
    rating: 5,
    projectThumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Indian%20resort%20cottage%20interior%20Bangalore%20with%20warm%20wood%20WPC%20flooring%20elegant%20modern%20decor%20natural%20light%20cozy%20premium%20atmosphere&width=120&height=120&seq=proj-thumb-09&orientation=squarish',
  },
];

export const faqData = [
  {
    question: 'What services does Infinite Consultant & Services provide?',
    answer: 'We offer complete property solutions including Landscaping, Interior Design, Civil Construction, UPVC Windows & Aluminium Works, WPC Paneling & Flooring, Indoor & Outdoor Branding, SS & MS Fabrication, Electrical & Plumbing, Painting, Deep Cleaning, Waterproofing, and Annual Maintenance Contracts.',
  },
  {
    question: 'Do you provide services for both residential and commercial properties?',
    answer: 'Yes, we cater to all property types including Independent Houses, Apartments, Villas, Commercial Buildings, Hospitals, Hotels, Resorts, Retail Stores, Corporate Offices, Educational Institutions, and Industrial Buildings.',
  },
  {
    question: 'How can I get a free quotation for my project?',
    answer: 'You can request a free quotation by clicking the "Get Free Quotation" button on our website, calling us at +91 70199 08718, or sending us a WhatsApp message. Our team will visit your site and provide a detailed estimate.',
  },
  {
    question: 'What is your service area?',
    answer: 'We are based in Bangalore and primarily serve clients across Bangalore and surrounding areas. For large projects, we can also discuss services in other locations in Karnataka.',
  },
  {
    question: 'Do you offer Annual Maintenance Contracts (AMC)?',
    answer: 'Yes, we offer comprehensive AMC packages that include regular maintenance, preventive checks, and emergency support at affordable rates. This ensures your property remains in excellent condition year-round.',
  },
  {
    question: 'How long does a typical interior design project take?',
    answer: 'Project timelines vary based on scope and complexity. A standard modular kitchen takes 2-3 weeks, while complete interior solutions for a villa may take 6-8 weeks. We always commit to realistic timelines and strive to deliver on schedule.',
  },
  {
    question: 'What makes Infinite Consultant different from other service providers?',
    answer: 'We are a one-stop solution provider with experienced professionals, quality materials, transparent pricing, and a commitment to customer satisfaction. Our diverse expertise allows us to handle multiple aspects of a project under one roof, saving you time and coordination hassle.',
  },
  {
    question: 'Do you use eco-friendly materials for landscaping and interiors?',
    answer: 'Yes, we prioritise sustainable and eco-friendly materials wherever possible. Our WPC panels, natural landscaping solutions, and energy-efficient UPVC windows are designed to minimise environmental impact while maximising durability and aesthetics.',
  },
];

export const contactServices = [
  'Landscaping',
  'Interior Design',
  'UPVC & Aluminium',
  'WPC Paneling',
  'Branding',
  'Fabrication',
  'Electrical & Plumbing',
  'Civil & Waterproofing',
  'Deep Cleaning',
  'AMC',
  'Other',
];

export const beforeAfterData = [
  {
    id: 1,
    title: 'Villa Garden Landscaping',
    category: 'Landscaping',
    location: 'Whitefield, Bangalore',
    description: 'Transformed a barren backyard into a lush tropical paradise with layered plantings, natural stone pathways, a zen garden corner, and integrated outdoor lighting for evening ambiance.',
    before: 'https://readdy.ai/api/search-image?query=An%20unkempt%20dry%20barren%20Indian%20backyard%20with%20patchy%20brown%20grass%20scattered%20debris%20overgrown%20weeds%20empty%20neglected%20Bangalore%20residential%20outdoor%20space%20dull%20overcast%20lighting%20realistic%20before%20photo&width=1400&height=900&seq=ba-before-1&orientation=landscape&nocache=true',
    after: 'https://readdy.ai/api/search-image?query=A%20stunning%20lush%20tropical%20Indian%20villa%20garden%20Bangalore%20with%20vibrant%20green%20lawn%20layered%20exotic%20plants%20including%20palms%20and%20bougainvillea%20natural%20stone%20pathway%20zen%20garden%20corner%20warm%20golden%20hour%20light%20professional%20photography&width=1400&height=900&seq=ba-after-1&orientation=landscape&nocache=true',
  },
  {
    id: 2,
    title: 'Modular Kitchen Renovation',
    category: 'Interiors',
    location: 'Koramangala, Bangalore',
    description: 'Complete kitchen overhaul from a cramped outdated layout to a modern open-plan modular kitchen with soft-close cabinets, quartz countertops, and smart storage solutions.',
    before: 'https://readdy.ai/api/search-image?query=An%20old%20cramped%20Indian%20kitchen%20Bangalore%20with%20worn%20out%20wooden%20cabinets%20peeling%20paint%20cluttered%20marble%20countertops%20outdated%20tiles%20poor%20fluorescent%20lighting%20messy%20disorganised%20realistic%20before%20renovation%20photo&width=1400&height=900&seq=ba-before-2&orientation=landscape&nocache=true',
    after: 'https://readdy.ai/api/search-image?query=A%20stunning%20modern%20luxury%20Indian%20modular%20kitchen%20Bangalore%20with%20glossy%20soft%20close%20cabinets%20white%20quartz%20countertops%20sleek%20pendant%20lights%20subway%20tile%20backsplash%20open%20layout%20warm%20ambient%20lighting%20professional%20interior%20photography&width=1400&height=900&seq=ba-after-2&orientation=landscape&nocache=true',
  },
  {
    id: 3,
    title: 'Commercial Building Waterproofing',
    category: 'Waterproofing',
    location: 'Indiranagar, Bangalore',
    description: 'Rescued a commercial building suffering from severe terrace leakage and wall dampness with advanced membrane waterproofing, crack injection, and protective coating systems.',
    before: 'https://readdy.ai/api/search-image?query=An%20old%20Indian%20commercial%20building%20rooftop%20Bangalore%20with%20visible%20monsoon%20water%20damage%20large%20cracks%20damp%20patches%20peeling%20paint%20moss%20growth%20worn%20out%20surface%20neglected%20condition%20dull%20overcast%20lighting%20realistic%20before%20photo&width=1400&height=900&seq=ba-before-3&orientation=landscape&nocache=true',
    after: 'https://readdy.ai/api/search-image?query=A%20freshly%20renovated%20Indian%20commercial%20building%20rooftop%20Bangalore%20with%20smooth%20clean%20grey%20waterproof%20membrane%20coating%20even%20surface%20professional%20finish%20bright%20sunny%20day%20blue%20sky%20urban%20architecture%20photography&width=1400&height=900&seq=ba-after-3&orientation=landscape&nocache=true',
  },
  {
    id: 4,
    title: 'Office Interior Makeover',
    category: 'Interiors',
    location: 'MG Road, Bangalore',
    description: 'Complete office transformation from a dull cubicle setup to a vibrant contemporary workspace with glass partitions, ergonomic furniture, biophilic elements, and branded accent walls.',
    before: 'https://readdy.ai/api/search-image?query=A%20dull%20outdated%20Indian%20office%20interior%20Bangalore%20with%20beige%20cubicles%20old%20tube%20light%20fixtures%20worn%20carpet%20grey%20walls%20uninspiring%20workspace%20cluttered%20desks%20sad%20corporate%20environment%20realistic%20before%20photo&width=1400&height=900&seq=ba-before-4&orientation=landscape&nocache=true',
    after: 'https://readdy.ai/api/search-image?query=A%20vibrant%20modern%20contemporary%20Indian%20open%20plan%20office%20interior%20Bangalore%20with%20glass%20partitions%20ergonomic%20furniture%20indoor%20plants%20living%20green%20wall%20natural%20light%20wood%20accents%20stylish%20decor%20professional%20photography&width=1400&height=900&seq=ba-after-4&orientation=landscape&nocache=true',
  },
  {
    id: 5,
    title: 'Resort Property Flooring',
    category: 'Flooring',
    location: 'Kanakapura Road, Bangalore',
    description: 'Replaced aged cracked tile flooring across a 3000 sq ft resort property with premium wood-look vinyl planks, transforming the entire guest experience with warm, durable, and elegant flooring.',
    before: 'https://readdy.ai/api/search-image?query=An%20old%20worn%20out%20Indian%20resort%20interior%20floor%20with%20cracked%20stained%20beige%20tiles%20grimy%20grout%20lines%20scratched%20surface%20dull%20appearance%20neglected%20Bangalore%20property%20harsh%20lighting%20realistic%20before%20renovation%20photo&width=1400&height=900&seq=ba-before-5&orientation=landscape&nocache=true',
    after: 'https://readdy.ai/api/search-image?query=A%20beautiful%20warm%20luxury%20Indian%20resort%20interior%20Bangalore%20with%20premium%20wood%20look%20vinyl%20plank%20flooring%20rich%20oak%20tones%20smooth%20clean%20surface%20elegant%20modern%20decor%20soft%20natural%20lighting%20professional%20photography&width=1400&height=900&seq=ba-after-5&orientation=landscape&nocache=true',
  },
];